export default __webpack_public_path__ + "static/media/salaryBanner.06d0c820.png";